import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-md-4" }
const _hoisted_4 = { class: "text-md-left text-center" }
const _hoisted_5 = { class: "col-md-4 text-center" }
const _hoisted_6 = {
  href: "javascript:void(0)",
  class: "to-upper"
}
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" | ")
const _hoisted_8 = {
  href: "javascript:void(0)",
  class: "to-upper"
}
const _hoisted_9 = { class: "modal-wrap default-modal" }
const _hoisted_10 = {
  class: "modal fade",
  "data-backdrop": "static",
  "data-keyboard": "false",
  id: "feedbackModal",
  tabindex: "-1",
  "aria-labelledby": "feedbackModalLabel",
  "aria-hidden": "true"
}
const _hoisted_11 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_12 = { class: "modal-content" }
const _hoisted_13 = { class: "modal-header" }
const _hoisted_14 = {
  class: "modal-title",
  id: "feedbackModalLabel"
}
const _hoisted_15 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_16 = { class: "modal-body" }
const _hoisted_17 = { class: "form-group" }
const _hoisted_18 = {
  for: "",
  class: "to-upper"
}
const _hoisted_19 = { class: "form-group" }
const _hoisted_20 = { for: "" }
const _hoisted_21 = { class: "form-group" }
const _hoisted_22 = {
  for: "",
  class: "to-upper"
}
const _hoisted_23 = { class: "custom-file" }
const _hoisted_24 = {
  class: "custom-file-label",
  for: "customFile"
}
const _hoisted_25 = {
  key: 0,
  class: "img-wrap"
}
const _hoisted_26 = { class: "modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ErrorList = _resolveComponent("ErrorList")
  const _component_FeedbackModal = _resolveComponent("FeedbackModal")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          _createVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('copyright')) + " © Convorally " + _toDisplayString(_ctx.state.data.currentYear), 1)
        ]),
        _createVNode("div", _hoisted_5, [
          _createVNode("a", {
            href: "javascript:void(0)",
            "data-toggle": "modal",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.showFeedBackModal && _ctx.showFeedBackModal(...args)))
          }, _toDisplayString(_ctx.$t('issue_or_suggestion')) + ".", 1)
        ]),
        _createVNode("div", {
          class: "col-md-4 text-md-right text-center",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.redirectToPrivacyPolicyAndCondition && _ctx.redirectToPrivacyPolicyAndCondition(...args)))
        }, [
          _createVNode("a", _hoisted_6, _toDisplayString(_ctx.$t('privacy_policy')), 1),
          _hoisted_7,
          _createVNode("a", _hoisted_8, _toDisplayString(_ctx.$t('terms')) + " & " + _toDisplayString(_ctx.$t('conditions')), 1)
        ])
      ])
    ]),
    _createVNode("div", _hoisted_9, [
      _createVNode("div", _hoisted_10, [
        _createVNode("div", _hoisted_11, [
          _createVNode("div", _hoisted_12, [
            _createVNode("div", _hoisted_13, [
              _createVNode("h5", _hoisted_14, _toDisplayString(_ctx.$t('give_feedback')), 1),
              _createVNode("button", {
                type: "button",
                class: "close",
                "aria-label": "Close",
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.issueDataClear && _ctx.issueDataClear(...args)))
              }, [
                _hoisted_15
              ])
            ]),
            _createVNode("div", _hoisted_16, [
              _createVNode(_component_ErrorList, {
                errors: _ctx.state.error.erorList.errorsList,
                hasError: _ctx.state.error.hasError
              }, null, 8, ["errors", "hasError"]),
              _createVNode("div", _hoisted_17, [
                _createVNode("label", _hoisted_18, _toDisplayString(_ctx.$t('title')), 1),
                _withDirectives(_createVNode("input", {
                  type: "text",
                  class: "form-control",
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.state.data.title = $event))
                }, null, 512), [
                  [_vModelText, _ctx.state.data.title]
                ])
              ]),
              _createVNode("div", _hoisted_19, [
                _createVNode("label", _hoisted_20, _toDisplayString(_ctx.$t('description')), 1),
                _withDirectives(_createVNode("textarea", {
                  class: "form-control",
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.state.data.description = $event))
                }, null, 512), [
                  [_vModelText, _ctx.state.data.description]
                ])
              ]),
              _createVNode("div", _hoisted_21, [
                _createVNode("label", _hoisted_22, _toDisplayString(_ctx.$t('upload_file')), 1),
                _createVNode("div", _hoisted_23, [
                  _createVNode("input", {
                    type: "file",
                    accept: "*.*",
                    id: "create-user-issue",
                    class: "custom-file-input",
                    onChange: _cache[6] || (_cache[6] = ($event: any) => (_ctx.onCurrentIssueUpload($event)))
                  }, null, 32),
                  _createVNode("label", _hoisted_24, _toDisplayString(_ctx.$t('choose_file')), 1)
                ]),
                (_ctx.state.data.file)
                  ? (_openBlock(), _createBlock("div", _hoisted_25, [
                      _createVNode("img", {
                        src: _ctx.state.data.file,
                        alt: ""
                      }, null, 8, ["src"])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createVNode("div", _hoisted_26, [
              _createVNode("button", {
                type: "button",
                class: "btn default-btn",
                onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.createUserIssue && _ctx.createUserIssue(...args)))
              }, _toDisplayString(_ctx.state.ui.isPostLoading.createUserIssue
                    ? _ctx.$t('submitting')
                    : _ctx.$t('submit')), 1)
            ])
          ])
        ])
      ])
    ]),
    (_ctx.state.data.showFeedBackModal)
      ? (_openBlock(), _createBlock(_component_FeedbackModal, {
          key: 0,
          showFeedBackModal: _ctx.state.data.showFeedBackModal,
          onCloseModal: _ctx.hideFeedBackModal
        }, null, 8, ["showFeedBackModal", "onCloseModal"]))
      : _createCommentVNode("", true)
  ]))
}